import { render, staticRenderFns } from "./ShopProductsPaymentSuccess.vue?vue&type=template&id=5b15cf84&scoped=true&"
import script from "./ShopProductsPaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./ShopProductsPaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductsPaymentSuccess.vue?vue&type=style&index=0&id=5b15cf84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15cf84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
